import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfirmationService, MessageService} from 'primeng/api';
import {OrderService} from '../../_services';
import { environment } from 'environments/environment';
import {TranslateService} from '@ngx-translate/core';

@Component({
  moduleId: module.id,
  selector: 'app-offer-validated',
  templateUrl: `../views/order-validated.component.html`,
  styleUrls: ['../styles/auth-style.scss'],
  providers: [
    MessageService, ConfirmationService
  ]
})

export class OrderValidatedComponent implements OnInit {
  validating = false;
  token = null;
  success = false;
  failed = false
  alreadyValidated = false;
  message:string = '';
  public mainColor: string;
  public logoUrl: string;
  orderDetails: any = null;
  orderValidator: any = null;
  comment: string = '';
  loading: boolean = false;
  approvingOrder: boolean = false;
  rejectingOrder: boolean = false;
  showRejectDialog: boolean = false;
  rejectionComment: string = '';

  constructor(
    private route: ActivatedRoute,
    private orderService: OrderService,
    private router: Router,
    private translateService: TranslateService,
    private confirmationService: ConfirmationService
  ) {
    this.token = this.route.snapshot.params.token;
    this.mainColor = environment.agencyName === "Hotelis" ? "#033768" : "#16a085";
    this.logoUrl = environment.logoUrl;
  }

  ngOnInit() {
    this.getOrderDetails();
  }

  getOrderDetails() {
    this.loading = true;
    this.orderService.getOrderDetailsByToken(this.token).subscribe(
    (response: any) => {
        this.orderDetails = response.order;
        this.orderValidator = response.validator;
        this.loading = false;
      }
    );
  }

  approveOrder() {
    this.confirmationService.confirm({
        header: this.translateService.instant('Confirmation'),
        message: this.translateService.instant('are you sure you want to approve this order'),
        accept: () => {
          this.comment = ''; // Clear comment for approval
          this.reviewOrder(true);
        }
    });
  }

  rejectOrder() {
    this.rejectionComment = '';
    this.showRejectDialog = true;
  }

  confirmRejection() {
    this.comment = this.rejectionComment;
    this.showRejectDialog = false;
    this.reviewOrder(false);
  }

  cancelRejection() {
    this.rejectionComment = '';
    this.showRejectDialog = false;
  }

  reviewOrder(approved: boolean) {
    if (approved) {
      this.approvingOrder = true;
    } else {
      this.rejectingOrder = true;
    }
    this.orderService.reviewOrder({ token: this.token, comment: this.comment, approved: approved }).subscribe(
      response => {
        this.approvingOrder = false;
        this.rejectingOrder = false;
        if (response && response.validator) {
          this.orderValidator = response.validator;
        }
        console.log('Order validator after review:', this.orderValidator);
        console.log('Validated value:', this.orderValidator?.validated);
        console.log('Type of validated:', typeof this.orderValidator?.validated);
      },
      error => {
        this.approvingOrder = false;
        this.rejectingOrder = false;
        console.error('Error reviewing order:', error);
      }
    );
  }

  validateOrder() {
    this.validating = false;
    let responseReceived = false;
    const loaderTimeout = setTimeout(() => {
        if (!responseReceived) {
            this.validating = true;
        }
    }, 300);
    new Promise((resolve, reject) => {
        this.orderService.verifyOrder(this.token).subscribe(
            response => resolve(response),
            error => reject(error)
        );
    }).then((response: any) => {
        responseReceived = true;
        clearTimeout(loaderTimeout);
        this.validating = false;

        if (response.status === 'error') {
            this.failed = true;
        } else {
            if (response.message === 'You have already approved this order') {
                this.alreadyValidated = true;
                this.message = response.message;
            } else {
                this.success = true;
            }
        }
    }).catch(() => {
        responseReceived = true;
        clearTimeout(loaderTimeout);
        this.validating = false;
        this.failed = true;
    });
  }
}